import { render, staticRenderFns } from "./CalendarOverstory.vue?vue&type=template&id=b2d4af66"
import script from "./CalendarOverstory.vue?vue&type=script&lang=ts"
export * from "./CalendarOverstory.vue?vue&type=script&lang=ts"
import style0 from "./CalendarOverstory.vue?vue&type=style&index=0&id=b2d4af66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports